import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
export default class Tab {
    constructor() {
        this.init();
    }

    init() {
        this.tab();
    }

    tab() {
        const tabItem = document.querySelectorAll(".js-tab_trigger");

        tabItem.forEach(($trigger) => {
            $trigger.addEventListener("click", () => {
                tabItem.forEach(($activetrigger) => {
                    $activetrigger.classList.remove("-active");
                    $activetrigger.classList.remove("-decoline");
                });

                this._tabToggle($trigger);
            });
        });
    }

    _tabToggle($trigger) {
        $trigger.classList.add("-active");

        const key = $trigger.getAttribute("data-tab");
        const tabContent = document.querySelectorAll(".event__detail__inner");

        tabContent.forEach(($target) => {
            const contkey = $target.getAttribute("data-tab");

            $target.classList.remove("-active");

            if (key === "live") {
                document
                    .querySelector(".js-tab_trigger.-liveviewing")
                    .classList.add("-decoline");
            } else if (key === "livestreaming") {
                document
                    .querySelector(".js-tab_trigger.-live")
                    .classList.add("-decoline");
            }

            if (key === contkey) {
                $target.classList.add("-active");
                ScrollTrigger.refresh();
            }
        });
    }
}
